<template>
  <div class="card-header border-bottom pt-1 pb-1 header_txt">
    <h4 class="card-title">Profile</h4>
  </div>
  <div class="card-body mt-2">
    <vForm @submit="$emit('storeContact', formData)" :validation-schema="schema">
      <div class="row">
        <div class="col-md-6 offset-md-3 col-12">
          <div class="row">

            <div class="col-12">
              <label for="colFormLabel">Full Name</label>
              <div class="mb-1">
                <vField
                    v-model="formData.full_name"
                    type="text"
                    name="full_name"
                    class="form-control add-credit-card-mask"
                    placeholder="Full Name"
                />
                <ErrorMessage name="full_name" class="invalid-feedback d-block qcont"/>
              </div>
            </div>

            <div class="col-12">
              <label for="colFormLabel">Legal Name</label>
              <div class="mb-1">
                <input type="text" id="legal-name" class="form-control" v-model="formData.legal_name"
                       placeholder="Legal Name"/>
              </div>
            </div>

            <div class="col-12">
              <label for="colFormLabel">Company Name</label>
              <div class="mb-1">
                <input type="text" id="company_name" class="form-control" v-model="formData.company_name"
                       placeholder="Company Name"/>
              </div>
            </div>

            <div class="col-6">
              <label for="colFormLabel">Date Of Birth</label>
              <div class="mb-1">
                <input type="date" id="birthday" class="form-control" v-model="formData.birthday"
                       placeholder="Birthday"/>
              </div>
            </div>

            <div class="col-6">
              <label for="colFormLabel">Gender</label>
              <div class="mb-1">
                <select class="form-control" id="gender" v-model="formData.gender">
                  <option value=''>Select Gender</option>
                  <option v-for="(gender, key) in genders" :value="key">{{ gender }}</option>
                </select>
              </div>
            </div>

            <div class="col-6">
              <label for="colFormLabel">Blood Group</label>
              <div class="mb-1">
                <select class="form-control" id="gender" v-model="formData.blood_group">
                  <option value=''>Select blood group</option>
                  <option v-for="(blood_group, key) in bloodGroups" :value="key">{{ blood_group }}</option>
                </select>
              </div>
            </div>

            <div class="col-6">
              <label for="colFormLabel">Marital Status</label>
              <div class="mb-1">
                <select class="form-control" id="marital_status" v-model="formData.marital_status">
                  <option value=''>Select Marital status</option>
                  <option v-for="(marital, key) in maritalStatus" :value="key">{{ marital }}</option>
                </select>
              </div>
            </div>
            <div class="col-6">
              <label for="colFormLabel">Religion</label>
              <div class="mb-1">
                <select class="form-control" id="religion" v-model="formData.religion">
                  <option value=''>Select Religion</option>
                  <option v-for="(religion, key) in religions" :value="key">{{ religion }}</option>
                </select>
              </div>
            </div>

            <div class="col-6">
              <label for="colFormLabel">Location</label>
              <div class="mb-1">
                <input type="text" id="location" class="form-control" v-model="formData.location"
                       placeholder="Location"/>
              </div>
            </div>

            <div class="col-6">
              <label for="colFormLabel">NID</label>
              <div class="mb-1">
                <input type="text" id="nid" class="form-control" v-model="formData.nid"
                       placeholder="NID"/>
              </div>
            </div>

            <div class="col-6">
              <label for="colFormLabel">TIN No</label>
              <div class="mb-1">
                <input type="text" id="tin_no" class="form-control" v-model="formData.tin_no"
                       placeholder="TIN No."/>
              </div>
            </div>

            <div class="col-6">
              <label for="colFormLabel">Father Name</label>
              <div class="mb-1">
                <input type="text" id="father-name" class="form-control" v-model="formData.father_name"
                       placeholder="Father Name"/>
              </div>
            </div>

            <div class="col-6">
              <label for="colFormLabel">Mother Name</label>
              <div class="mb-1">
                <input type="text" id="mother-name" class="form-control" v-model="formData.mother_name"
                       placeholder="Mother Name"/>
              </div>
            </div>
            <div class="col-12">
              <table class="table w-100">
                <thead>
                <tr>
                  <th>Role</th>
                  <th>Serial No</th>
                  <th>Status</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(companyRole, index) in formData.company_roles_data">
                  <td class="p-1 w-50">
                    <v-select
                        @option:selected="getRoleChange"
                        :clearable="false"
                        placeholder="Select Role"
                        v-model="companyRole.id"
                        :options="companyRules"
                        label="name"
                        :reduce="name => name.id"
                    />
                  </td>
                  <td class="p-1 w-25"><input type="text" class="form-control" v-model="companyRole.serial_no"/></td>
                  <td class="d-flex p-1">
                    <select v-model="companyRole.status" class="form-control">
                      <option value="active">Active</option>
                      <option value="inactive">Inactive</option>
                    </select>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="col-sm-6 offset-sm-3">
              <button type="submit" class="btn btn-primary me-1">Submit</button>
              <button type="reset" class="btn btn-outline-secondary">Reset</button>
            </div>

          </div>
        </div>
      </div>
    </vForm>
  </div>
</template>

<script setup>
import {onMounted, ref, watch, defineProps} from "vue";
import handleChartAccount from '@/services/modules/chartAccount'

let genders = ref([])
let bloodGroups = ref([])
let maritalStatus = ref([])
let religions = ref([])
let loader = ref(false)
const {fetchHome} = handleChartAccount()

const props = defineProps({
  companyRules: {
    type: Array,
    default: []
  },
  formData: {
    type: Object
  }
})

const schema = {
  full_name: 'required'
}

const formData = ref({
  full_name: '',
  legal_name: '',
  designation: '',
  company_name: '',
  department: '',
  birthday: '',
  gender: '',
  location: '',
  nid: '',
  tin_no: '',
  father_name: '',
  mother_name: '',
  blood_group: '',
  marital_status: '',
  religion: '',
  company_rules: [],
  company_roles_data: []
})

watch(() => [props.formData, props.companyRules], ([newFormData, newFormData2]) => {
  formDataSet();
});

const getRoleChange = () => {
  formData.value.company_rules = formData.value.company_roles_data.map(role => parseInt(role.id));
}

const formDataSet = () => {
  if (props.formData && props.formData.full_name) {
    formData.value = props.formData
    formData.value.company_rules = props.formData.company_roles_data.map(role => parseInt(role.id));
  }
  if (props.companyRules.length === 1 && !props.formData.company_roles_data ) {
    formData.value.company_rules = [props.companyRules[0].id]
    formData.value.company_roles_data.push({
      is_new: false,
      id: props.companyRules[0].id,
      label: props.companyRules[0].name,
      serial_no: '',
      status: 'active',
    })
  }
}

onMounted(() => {
  formDataSet()
  Promise.all([
    fetchHome().then(res => {
      if (res.data) {
        genders.value = res.data.genders
        bloodGroups.value = res.data.blood_groups
        maritalStatus.value = res.data.marital_status
        religions.value = res.data.religions
      }
    })
  ]).then(() => {
    loader.value = false
  }).catch((err) => {
    loader.value = false
  })
})
</script>

<style scoped>

</style>
